import { Frequency, ScheduleConfigurationInput } from '@iss/libs/graphql';
import { FormGroup } from '@angular/forms';

import { DailyScheduleType, MonthlyScheduleType, RecurrenceScheduleControls } from './recurrence-schedule.form-group';

export const toScheduleConfigurationInput = (value: FormGroup<RecurrenceScheduleControls>['value']): ScheduleConfigurationInput => {
  const { frequency, startDate, endDate } = value;

  if (!startDate) {
    throw new Error(`Cannot map startDate ${ JSON.stringify(value) } to OrderScheduleInput`);
  }

  if (!endDate) {
    throw new Error(`Cannot map endDate ${ JSON.stringify(value) } to OrderScheduleInput`);
  }

  switch (frequency) {
    case Frequency.Daily:
      switch (value.dailyType) {
        case DailyScheduleType.EveryDay:
          if (!value.dailyRecurrenceCounter) {
            throw new TypeError(`Cannot map dailyRecurrenceCounter ${ JSON.stringify(value) } to OrderScheduleInput`);
          }

          return {
            startDate,
            endDate,
            frequency,
            dailyEveryWeekday: false,
            recurrenceCounter: value.dailyRecurrenceCounter,
          };
        case DailyScheduleType.EveryWeekday:
          return {
            startDate,
            endDate,
            frequency,
            dailyEveryWeekday: true,
          };
        default:
          throw new Error(`Cannot map dailyType ${ JSON.stringify(value) } to OrderScheduleInput`);
      }
    case Frequency.Weekly:
      if (!value.weeklyRecurrenceCounter) {
        throw new Error(`Cannot map weeklyRecurrenceCounter ${ JSON.stringify(value) } to OrderScheduleInput`);
      }

      if (!value.weeklyRecurrenceDayNames?.length) {
        throw new Error(`Cannot map weeklyRecurrenceDayNames ${ JSON.stringify(value) } to OrderScheduleInput`);
      }

      return {
        startDate,
        endDate,
        frequency,
        recurrenceCounter: value.weeklyRecurrenceCounter,
        weeklyRecurrenceDayNames: value.weeklyRecurrenceDayNames,
      };
    case Frequency.Monthly:
      switch (value.monthlyType) {
        case MonthlyScheduleType.EveryMonth:
          if (!value.monthlyRecurrenceCounter) {
            throw new Error(`Cannot map monthlyRecurrenceCounter ${ JSON.stringify(value) } to OrderScheduleInput`);
          }

          if (!value.monthlyRecurrenceDayNumber) {
            throw new Error(`Cannot map monthlyRecurrenceDayNumber ${ JSON.stringify(value) } to OrderScheduleInput`);
          }

          return {
            startDate,
            endDate,
            frequency,
            recurrenceCounter: value.monthlyRecurrenceCounter,
            monthlyRecurrenceDayNumber: value.monthlyRecurrenceDayNumber,
          };
        case MonthlyScheduleType.NthMonth:
          if (!value.monthlyRecurrenceConfigCounter) {
            throw new Error(`Cannot map monthlyRecurrenceConfigCounter ${ JSON.stringify(value) } to OrderScheduleInput`);
          }

          if (!value.monthlyRecurrenceConfigType) {
            throw new Error(`Cannot map monthlyRecurrenceConfigType ${ JSON.stringify(value) } to OrderScheduleInput`);
          }

          if (!value.monthlyRecurrenceConfigDay) {
            throw new Error(`Cannot map monthlyRecurrenceConfigDay ${ JSON.stringify(value) } to OrderScheduleInput`);
          }

          return {
            startDate,
            endDate,
            frequency,
            recurrenceCounter: value.monthlyRecurrenceConfigCounter,
            monthlyRecurrenceConfig: {
              monthlyRecurrenceConfigType: value.monthlyRecurrenceConfigType,
              monthlyRecurrenceConfigDay: value.monthlyRecurrenceConfigDay,
            },
          };
        default:
          throw new Error(`Cannot map monthlyType ${ JSON.stringify(value) } to OrderScheduleInput`);
      }
    default:
      throw new Error(`Cannot map frequency ${ JSON.stringify(value) } to OrderScheduleInput`);
  }
};
